import React from 'react';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';

import { Checkbox } from '../lumen/components';
import { useSystemStatus } from '../systemStatus';

export default function SentimentSelector({
  checked,
  onChange,
  additionalCss,
  rebuild = false
}) {
  const systemStatus = useSystemStatus();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        align-items: center;
        ${additionalCss}
      `}
    >
      <Checkbox
        checked={checked}
        onChange={evt => onChange(evt.target.checked)}
        disabled={!systemStatus?.gpu}
        label={`${rebuild ? 'Rebuild' : 'Build'} without sentiment`}
      />
    </div>
  );
}

SentimentSelector.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  additionalCss: PropTypes.object
};
